// extracted by mini-css-extract-plugin
export default {"ValueProposition":"attractions-value-proposition-ValueProposition__ValueProposition--hWXxT","title":"attractions-value-proposition-ValueProposition__title--1FfwK"};